import React from "react";
import { Link } from "react-router-dom";

const Upload = () => {
	return (
		<div>
			<div className='ocena-ucitelj'>
				<h1 style={{ textTransform: "uppercase", marginBottom: "2rem" }}>
					Izberi učitelja
				</h1>
				<Link to='/upload-kerstein' className='upload-class'>
					KERSTEIN
				</Link>
			</div>
		</div>
	);
};

export default Upload;
